import React, { useRef } from "react";
import emailjs from "emailjs-com";
import "../App.css";

function MyEmail() {
  const form = useRef();

  function sendEmail(e) {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_2hakaxl",
        "template_gialjmy",
        e.target,
        "yNMMj11fMmm49Cu3p"
      )
      .then(
        (result) => {
          console.log(result.text);
          form.current.reset();
          setTimeout(() => {
            window.alert("Thank you for your message"); // Visa ett meddelande när e-postmeddelandet har skickats
          }, 1000); // Vänta en sekund innan meddelandet visas
        },
        (error) => {
          console.log(error.text);
        }
      );
  }

  return (
    <form className="contact-form" onSubmit={sendEmail} ref={form}>
      <label>Send me a message!</label>
      <br />
      <br />
      <input className="input" type="hidden" name="contact_number" />
      <label>Name</label>
      <input className="input" type="text" name="user_name" />
      <label>Email</label>
      <input className="input" type="email" name="user_email" />
      <label>Subject</label>
      <input className="input" type="text" name="subject" />
      <label>Message</label>
      <textarea name="message" />
      <input className="input" type="submit" value="Send" />
    </form>
  );
}

export default MyEmail;
